
  const __registry__ = require('../../../spiferack/client/index.js')
  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var Pagination = require('../../components/pagination/pagination');
var OrgAddUser = require('./actions/orgAddUser');
var OrgCreateTeam = require('./actions/orgCreateTeam');
var OrgDeleteTeam = require('./actions/orgDeleteTeam');
var OrgRemoveUser = require('./actions/orgRemoveUser');
var PackageAddDistTag = require('./actions/packageAddDistTag');
var PackageDeprecate = require('./actions/packageDeprecate');
var PackagePublish = require('./actions/packagePublish');
var PackageRemoveDistTag = require('./actions/packageRemoveDistTag');
var PackageUnpublish = require('./actions/packageUnpublish');
var TeamAddPackage = require('./actions/teamAddPackage');
var TeamAddUser = require('./actions/teamAddUser');
var TeamRemovePackage = require('./actions/teamRemovePackage');
var TeamRemoveUser = require('./actions/teamRemoveUser');
var TeamUpdatePackageAccess = require('./actions/teamUpdatePackageAccess');
var PackageUpdateAccess = require('./actions/packageUpdateAccess');

var _require = require('@npm/audit-log-client'),
    AUDIT_LOG_EVENTS = _require.AUDIT_LOG_EVENTS;

var AuditLogsList = function (_React$PureComponent) {
  _inherits(AuditLogsList, _React$PureComponent);

  function AuditLogsList() {
    _classCallCheck(this, AuditLogsList);

    return _possibleConstructorReturn(this, (AuditLogsList.__proto__ || Object.getPrototypeOf(AuditLogsList)).apply(this, arguments));
  }

  _createClass(AuditLogsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          logs = _props.logs,
          pagination = _props.pagination,
          url = _props.url,
          total = _props.total,
          scope = _props.scope;

      var listItems = logs.map(function (log) {
        return React.createElement(AuditLogsItem, { key: log.event_id, log: log, avatars: scope.parent.avatars });
      });

      return React.createElement(
        React.Fragment,
        null,
        listItems,
        React.createElement(Pagination, _extends({ url: url }, pagination, { total: total, className: 'mt2' }))
      );
    }
  }]);

  return AuditLogsList;
}(React.PureComponent);

var AuditLogsItem = function (_React$PureComponent2) {
  _inherits(AuditLogsItem, _React$PureComponent2);

  function AuditLogsItem() {
    _classCallCheck(this, AuditLogsItem);

    return _possibleConstructorReturn(this, (AuditLogsItem.__proto__ || Object.getPrototypeOf(AuditLogsItem)).apply(this, arguments));
  }

  _createClass(AuditLogsItem, [{
    key: 'render',
    value: function render() {
      var log = this.props.log;

      switch (log.event) {
        case AUDIT_LOG_EVENTS.PACKAGE_PUBLISH:
          return React.createElement(PackagePublish, this.props);
        case AUDIT_LOG_EVENTS.PACKAGE_UNPUBLISH:
          return React.createElement(PackageUnpublish, this.props);
        case AUDIT_LOG_EVENTS.PACKAGE_DEPRECATE:
          return React.createElement(PackageDeprecate, this.props);
        case AUDIT_LOG_EVENTS.PACKAGE_ADD_DIST_TAG:
          return React.createElement(PackageAddDistTag, this.props);
        case AUDIT_LOG_EVENTS.PACKAGE_REMOVE_DIST_TAG:
          return React.createElement(PackageRemoveDistTag, this.props);
        case AUDIT_LOG_EVENTS.PACKAGE_UPDATE_ACCESS:
          return React.createElement(PackageUpdateAccess, this.props);
        case AUDIT_LOG_EVENTS.ORG_ADD_TEAM:
          return React.createElement(OrgCreateTeam, this.props);
        case AUDIT_LOG_EVENTS.ORG_DELETE_TEAM:
          return React.createElement(OrgDeleteTeam, this.props);
        case AUDIT_LOG_EVENTS.ORG_ADD_USER:
          return React.createElement(OrgAddUser, this.props);
        case AUDIT_LOG_EVENTS.ORG_REMOVE_USER:
          return React.createElement(OrgRemoveUser, this.props);
        case AUDIT_LOG_EVENTS.TEAM_ADD_PACKAGE:
          return React.createElement(TeamAddPackage, this.props);
        case AUDIT_LOG_EVENTS.TEAM_UPDATE_PACKAGE_ACCESS:
          return React.createElement(TeamUpdatePackageAccess, this.props);
        case AUDIT_LOG_EVENTS.TEAM_REMOVE_PACKAGE:
          return React.createElement(TeamRemovePackage, this.props);
        case AUDIT_LOG_EVENTS.TEAM_ADD_USER:
          return React.createElement(TeamAddUser, this.props);
        case AUDIT_LOG_EVENTS.TEAM_REMOVE_USER:
          return React.createElement(TeamRemoveUser, this.props);
        default:
          return React.createElement('div', null);
      }
    }
  }]);

  return AuditLogsItem;
}(React.PureComponent);

module.exports = AuditLogsList;
  let __hot__
  
  __registry__.register('audit-logs/list', module.exports, __hot__)
  